import { useFlexGroup } from 'BrokerTsLib/src/hooks/useFlexGroup'
import React, { useEffect } from 'react'

import { CustomWaypoint } from '@/components'
import { useSidebar } from '@/context/SidebarContext'
import type { PageSection as Section } from '@/layouts/components/Sidebar'

import { FlexGroupOrganizationListSection } from './FlexGroupOrganizationListSection'
import { FlexGroupUserListSection } from './FlexGroupUserListSection'

export const FlexGroupDetail = ({ flexGroupId }: { flexGroupId: number }) => {
  const { pageSections, setPageSections } = useSidebar()

  const {
    flexGroup,
    isLoading,
    addMemberUserAsync,
    removeMemberUserAsync,
    addSupervisorUserAsync,
    removeSupervisorUserAsync,
    addMemberOrganizationAsync,
    updateMemberOrganizationAsync,
    removeMemberOrganizationAsync,
    addSupervisorOrganizationAsync,
    removeSupervisorOrganizationAsync
  } = useFlexGroup(flexGroupId)

  useEffect(() => {
    const array: Section[] = []
    let i = 1

    if (flexGroup) {
      array.push({
        id: 'flexGroupOrganizations',
        sectionTitle: 'Seznam organizací',
        index: i++,
        children: (
          <CustomWaypoint sectionId='flexGroupOrganizations'>
            <FlexGroupOrganizationListSection
              id='flexGroupOrganizations'
              title="Seznam organizací"
              flexGroupOrganizations={flexGroup.memberOrganizations}
              addOrganizationAsync={addMemberOrganizationAsync}
              updateOrganizationAsync={updateMemberOrganizationAsync}
              removeOrganizationAsync={removeMemberOrganizationAsync}
              isLoading={isLoading} />
          </CustomWaypoint >
        )
      })

      array.push({
        id: 'flexGroupUsers',
        sectionTitle: 'Seznam uživatelů',
        index: i++,
        children: (
          <CustomWaypoint sectionId='flexGroupUsers'>
            <FlexGroupUserListSection id='flexGroupUsers'
              title="Seznam uživatelů"
              flexGroupUsers={flexGroup.memberUsers}
              addUserAsync={addMemberUserAsync}
              removeUserAsync={removeMemberUserAsync}
              isLoading={isLoading} />
          </CustomWaypoint >
        )
      })

      array.push({
        id: 'flexGroupSuperiorOrganizations',
        sectionTitle: 'Oprávnění - organizace',
        index: i++,
        children: (
          <CustomWaypoint sectionId='flexGroupSuperiorOrganizations'>
            <FlexGroupOrganizationListSection
              id='flexGroupSuperiorOrganizations'
              title="Oprávnění - organizace"
              flexGroupOrganizations={flexGroup.supervisorOrganizations}
              addOrganizationAsync={addSupervisorOrganizationAsync}
              removeOrganizationAsync={removeSupervisorOrganizationAsync}
              isLoading={isLoading} />
          </CustomWaypoint >
        )
      })

      array.push({
        id: 'flexGroupSuperiorUsers',
        sectionTitle: 'Oprávnení - uživatelé',
        index: i++,
        children: (
          <CustomWaypoint sectionId='flexGroupSuperiorUsers'>
            <FlexGroupUserListSection
              id='flexGroupSuperiorUsers'
              title="Oprávnení - uživatelé"
              flexGroupUsers={flexGroup.supervisorUsers}
              addUserAsync={addSupervisorUserAsync}
              removeUserAsync={removeSupervisorUserAsync}
              isLoading={isLoading} />
          </CustomWaypoint >
        )
      })
    }

    setPageSections(array)

    return () => setPageSections([])
  }, [flexGroup, setPageSections])




  return pageSections.map(x => (
    <React.Fragment key={x.id}>
      {x.children}
    </React.Fragment>
  ))
}